import React from 'react';

import TaskGroupContainer from '../containers/task-group-container';

const Name = ({ name = null, removed }) => removed ? '(Removed Task List)' : name;

const TaskGroupName = ({ id }) => <TaskGroupContainer id={id}><Name /></TaskGroupContainer>;

export default TaskGroupName;
